<template>
  <div class="game-detail-page">
    <!-- 顶部导航 -->
    <header class="top-header">
      <div class="header-inner">
        <div class="logo" @click="goHome">
          <div class="logo-icon">
            <img src="@/assets/icon/banner.png" alt="logo" />
          </div>
          <span class="logo-text">杭州梵艺科技有限公司</span>
        </div>
      </div>
    </header>

    <!-- 顶部 Banner -->
    <section class="game-banner">
      <div class="banner-inner">
        <div class="banner-glow"></div>
        <div class="banner-clouds"></div>
        <div class="banner-warriors">
          <div class="warrior warrior-left">
            <div class="warrior-body"></div>
            <div class="warrior-weapon"></div>
          </div>
          <div class="warrior warrior-right">
            <div class="warrior-body"></div>
            <div class="warrior-weapon"></div>
          </div>
        </div>
        <div class="banner-title-art">
          <div class="title-art-cn">{{ game.name }}</div>
<!--          <div class="title-art-sub">FANTASY · THREE KINGDOMS</div>-->
        </div>
        <div class="banner-flames"></div>
      </div>
    </section>

    <!-- 主体内容区 -->
    <main class="main-container">
      <!-- 左侧主内容 -->
      <div class="content-left">
        <!-- 游戏信息卡片 -->
        <section class="game-info-card">
          <div class="game-info-header">
            <div class="game-logo">
              <img :src="game.iconUrl" :alt="game.name" />
            </div>
            <div class="game-meta">
              <h1 class="game-name">{{ game.name }}</h1>
              <div class="game-version">
                版本信息：{{ game.version }} &nbsp;&nbsp; 开发者：{{ game.developer }}
              </div>
              <div class="game-actions">
<!--                <button class="action-btn primary">立即下载</button>-->
<!--                <button class="action-btn secondary">收藏游戏</button>-->
              </div>
            </div>
          </div>
          <div class="game-intro">
            <span class="intro-label">简介：</span>
            <span class="intro-text">{{ game.intro }}</span>
          </div>
        </section>

        <!-- 游戏截图展示区 -->
        <section class="screenshots-card">
          <div class="card-header">
            <span class="title-bar"></span>
            <span class="card-title">游戏截图</span>
          </div>
          <div class="screenshots-grid">
            <div
              v-for="(shot, i) in game.screenshots"
              :key="i"
              class="screenshot-item"
            >
              <div class="phone-screen">
                <div class="phone-notch"></div>
                <img class="shot-img" :src="resolveShot(shot.src)" :alt="shot.caption || game.name" />
                <div class="phone-home-bar"></div>
              </div>
              <div v-if="shot.caption" class="shot-caption">{{ shot.caption }}</div>
            </div>
          </div>
        </section>
      </div>

      <!-- 右侧侧边栏 -->
      <aside class="content-right">
        <!-- 下载区卡片 -->
        <section class="download-card">
          <div class="card-header">
            <span class="title-bar"></span>
            <span class="card-title">扫码下载</span>
          </div>
          <div class="qr-list">
            <div class="qr-item" :class="{ disabled: !hasAndroid }">
              <div class="qr-img">
                <img v-if="androidQr" :src="androidQr" alt="安卓下载二维码" class="qr-image" />
                <div v-else class="qr-empty">暂不支持</div>
              </div>
              <div class="qr-platform android">
                <span class="platform-icon">🤖</span>
                <span class="platform-text">安卓下载</span>
              </div>
            </div>
            <div class="qr-item" :class="{ disabled: !hasIos }">
              <div class="qr-img">
                <img v-if="iosQr" :src="iosQr" alt="iOS下载二维码" class="qr-image" />
                <div v-else class="qr-empty">暂不支持</div>
              </div>
              <div class="qr-platform ios">
                <span class="platform-icon"></span>
                <span class="platform-text">IOS下载</span>
              </div>
            </div>
          </div>
        </section>

        <!-- 猜你喜欢 -->
        <section class="recommend-card">
          <div class="card-header">
            <span class="title-bar"></span>
            <span class="card-title">猜你喜欢</span>
          </div>
          <div class="recommend-grid">
            <div
              v-for="(g, i) in recommendList"
              :key="i"
              class="recommend-item"
              @click="goToGame(g)"
            >
              <div class="recommend-icon">
                <img :src="g.iconUrl" :alt="g.name" />
              </div>
              <div class="recommend-name">{{ g.name }}</div>
            </div>
          </div>
        </section>
      </aside>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-logo">
          <img src="@/assets/icon/banner.png" alt="logo" />
        </div>
        <div class="footer-links">
<!--          <a>关于社区</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>联系我们</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>商务合作</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>普通开放平台</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>家长监护</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>广告合作</a>-->
<!--          <span class="divider">|</span>-->
<!--          <a>账号交易平台</a>-->
        </div>
        <div class="footer-copyright">
          © 2024-2026 杭州梵艺科技有限公司 版权所有 &nbsp; 浙ICP备B2-20100031-1 &nbsp;
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import QRCode from "qrcode";
import product from "@/mock/product.json";

const QR_OPTIONS = {
  margin: 1,
  width: 240,
  errorCorrectionLevel: "M",
  color: { dark: "#222", light: "#fff" }
};

const findGameByQuery = q => {
  const { games } = product;
  if (!q) return null;
  if (games[q]) return games[q];
  return Object.values(games).find(g => g.name === q) || null;
};

const buildRecommendList = () => {
  const { games, detail } = product;
  return (detail.recommendList || [])
    .map(id => games[id])
    .filter(Boolean)
    .map(g => ({
      id: g.id,
      name: g.name,
      iconUrl: g.iconUrl,
      hasDetail: !!g.hasDetail,
      link: g.link || ""
    }));
};

export default {
  name: "GameDetailPage",
  data() {
    const queryId = this.$route.query.id;
    const fallback = product.games["hanfeng-three-kingdoms"];
    return {
      gameId: queryId || fallback.id,
      game: findGameByQuery(queryId) || fallback,
      recommendList: buildRecommendList(),
      androidQr: "",
      iosQr: ""
    };
  },
  computed: {
    hasIos() {
      return !!(this.game && this.game.downloads && this.game.downloads.ios);
    },
    hasAndroid() {
      return !!(this.game && this.game.downloads && this.game.downloads.android);
    },
    androidUrl() {
      return (this.game && this.game.downloads && this.game.downloads.android) || "";
    },
    iosUrl() {
      return (this.game && this.game.downloads && this.game.downloads.ios) || "";
    }
  },
  watch: {
    "$route.query.id"(newId) {
      const fallback = product.games["hanfeng-three-kingdoms"];
      this.gameId = newId || fallback.id;
      this.game = findGameByQuery(newId) || fallback;
    },
    androidUrl: {
      immediate: true,
      handler(url) {
        this.renderQr(url, "androidQr");
      }
    },
    iosUrl: {
      immediate: true,
      handler(url) {
        this.renderQr(url, "iosQr");
      }
    }
  },
  methods: {
    goHome() {
      this.$router.push("/home");
    },
    goToGame(g) {
      if (!g) return;
      if (g.hasDetail) {
        this.$router.push({ path: "/game-detail", query: { id: g.id } });
      } else if (g.link) {
        window.open(g.link, "_blank");
      }
    },
    renderQr(url, field) {
      if (!url) {
        this[field] = "";
        return;
      }
      const sourceField = field === "androidQr" ? "androidUrl" : "iosUrl";
      QRCode.toDataURL(url, QR_OPTIONS)
        .then(dataUrl => {
          if (this[sourceField] === url) {
            this[field] = dataUrl;
          }
        })
        .catch(() => {
          this[field] = "";
        });
    },
    resolveShot(src) {
      if (!src) return "";
      try {
        return require("@/assets/png/" + src);
      } catch (e) {
        return "";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.game-detail-page {
  width: 100%;
  background: #F5F5F5;
  min-width: 1366px;
  font-family: PingFangSC-Regular, "Microsoft YaHei", sans-serif;
  color: #333;
}

/* 顶部导航 */
.top-header {
  width: 100%;
  height: 56px;
  background: linear-gradient(90deg, #4A90E2 0%, #6AB0F2 100%);
  box-shadow: 0 2px 8px rgba(74,144,226,0.15);
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image:
      radial-gradient(circle at 20% 50%, rgba(255,255,255,0.08) 6px, transparent 7px),
      radial-gradient(circle at 60% 30%, rgba(255,255,255,0.08) 4px, transparent 5px),
      radial-gradient(circle at 85% 70%, rgba(255,255,255,0.08) 5px, transparent 6px);
    background-size: 120px 120px;
    opacity: 0.4;
  }
  .header-inner {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
  }
  .logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    .logo-icon {
      width: 32px;
      height: 32px;
      background: #fff;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 10px;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }
    .logo-text {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }
}

/* 顶部 Banner */
.game-banner {
  width: 100%;
  height: 260px;
  background: linear-gradient(180deg, #2a0a0a 0%, #6b1414 40%, #a52323 100%);
  position: relative;
  overflow: hidden;
  .banner-inner {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
  }
  .banner-glow {
    position: absolute;
    width: 600px;
    height: 600px;
    top: -200px;
    left: 50%;
    transform: translateX(-50%);
    background: radial-gradient(circle, rgba(255,200,80,0.35) 0%, transparent 60%);
    border-radius: 50%;
  }
  .banner-clouds {
    position: absolute;
    inset: 0;
    background-image:
      radial-gradient(ellipse 80px 16px at 10% 30%, rgba(255,255,255,0.08), transparent 70%),
      radial-gradient(ellipse 120px 20px at 80% 60%, rgba(255,255,255,0.06), transparent 70%),
      radial-gradient(ellipse 60px 12px at 40% 80%, rgba(255,255,255,0.05), transparent 70%);
  }
  .banner-warriors {
    position: absolute;
    inset: 0;
    .warrior {
      position: absolute;
      width: 120px;
      height: 180px;
      bottom: 20px;
      .warrior-body {
        position: absolute;
        bottom: 0;
        left: 30px;
        width: 60px;
        height: 140px;
        background: linear-gradient(180deg, #d4af37 0%, #8b4513 60%, #4a1a0a 100%);
        border-radius: 30px 30px 8px 8px;
        box-shadow: 0 0 30px rgba(212,175,55,0.4),
                    inset -8px 0 12px rgba(0,0,0,0.3);
      }
      .warrior-weapon {
        position: absolute;
        bottom: 30px;
        width: 6px;
        height: 160px;
        background: linear-gradient(180deg, #f1c40f 0%, #c0392b 50%, #8b4513 100%);
        box-shadow: 0 0 15px rgba(241,196,15,0.6);
      }
    }
    .warrior-left {
      left: 120px;
      transform: scaleX(-1);
      .warrior-weapon { right: 0; }
    }
    .warrior-right {
      right: 120px;
      .warrior-weapon { left: 0; }
    }
  }
  .banner-title-art {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 2;
    .title-art-cn {
      font-size: 90px;
      font-weight: 900;
      letter-spacing: 18px;
      background: linear-gradient(180deg, #fff8dc 0%, #ffd700 40%, #b8860b 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 4px 20px rgba(255,140,0,0.6);
      font-family: "STKaiti", "KaiTi", "Microsoft YaHei", serif;
      filter: drop-shadow(0 0 12px rgba(255,200,80,0.5));
    }
    .title-art-sub {
      font-size: 14px;
      letter-spacing: 6px;
      color: #ffd700;
      margin-top: 6px;
      opacity: 0.85;
    }
  }
  .banner-flames {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: linear-gradient(180deg, transparent 0%, rgba(255,100,30,0.4) 50%, rgba(255,50,0,0.6) 100%);
    filter: blur(8px);
  }
}

/* 主容器 */
.main-container {
  width: 1200px;
  margin: -30px auto 0;
  padding: 0 0 40px;
  display: flex;
  gap: 20px;
  position: relative;
  z-index: 5;
}

.content-left {
  flex: 0 0 calc(70% - 10px);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.content-right {
  flex: 0 0 calc(30% - 10px);
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* 通用卡片头 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .title-bar {
    width: 4px;
    height: 18px;
    background: #4A90E2;
    border-radius: 2px;
    margin-right: 8px;
  }
  .card-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}

/* 游戏信息卡片 */
.game-info-card {
  background: #fff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  .game-info-header {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
  }
  .game-logo {
    width: 96px;
    height: 96px;
    border-radius: 20px;
    overflow: hidden;
    background: #f0f0f0;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    margin-right: 20px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .game-meta {
    flex: 1;
  }
  .game-name {
    font-size: 26px;
    font-weight: bold;
    color: #222;
    margin: 0 0 10px;
    letter-spacing: 1px;
  }
  .game-version {
    font-size: 14px;
    color: #888;
    margin-bottom: 14px;
  }
  .game-actions {
    display: flex;
    gap: 12px;
  }
  .action-btn {
    padding: 8px 22px;
    border-radius: 22px;
    border: none;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: 500;
    &.primary {
      background: linear-gradient(90deg, #4A90E2, #6AB0F2);
      color: #fff;
      box-shadow: 0 4px 12px rgba(74,144,226,0.3);
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(74,144,226,0.4);
      }
    }
    &.secondary {
      background: #f5f9ff;
      color: #4A90E2;
      border: 1px solid #d6e6fb;
      &:hover {
        background: #e8f2ff;
      }
    }
  }
  .game-intro {
    background: #f8fbff;
    border-left: 3px solid #4A90E2;
    padding: 14px 16px;
    border-radius: 4px;
    font-size: 13px;
    line-height: 1.8;
    color: #555;
    .intro-label {
      color: #4A90E2;
      font-weight: bold;
    }
  }
}

/* 游戏截图 */
.screenshots-card {
  background: #fff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.screenshots-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.screenshot-item {
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: translateY(-4px);
    .phone-screen { box-shadow: 0 8px 24px rgba(0,0,0,0.2); }
  }
  .phone-screen {
    width: 100%;
    aspect-ratio: 9 / 16;
    border-radius: 18px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 14px rgba(0,0,0,0.12);
    border: 6px solid #1a1a1a;
    transition: box-shadow 0.2s;
  }
  .phone-notch {
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 8px;
    background: #1a1a1a;
    border-radius: 4px;
    z-index: 2;
  }
  .shot-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .phone-home-bar {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: rgba(255,255,255,0.6);
    border-radius: 2px;
  }
  .shot-caption {
    margin-top: 10px;
    font-size: 13px;
    color: #555;
    text-align: center;
    font-weight: 500;
  }
}

/* 下载区卡片 */
.download-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.qr-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.qr-item {
  text-align: center;
  padding: 10px 6px;
  background: #fafbff;
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(74,144,226,0.15);
  }
  &.disabled {
    background: #f5f5f5;
    &:hover {
      transform: none;
      box-shadow: none;
    }
    .qr-img {
      background: #f0f2f5;
      border-color: #e0e3e8;
    }
    .qr-platform {
      color: #bbb !important;
    }
  }
  .qr-img {
    width: 100%;
    aspect-ratio: 1;
    background: #fff;
    border-radius: 6px;
    position: relative;
    padding: 6px;
    border: 1px solid #e8eef7;
    margin-bottom: 8px;
    overflow: hidden;
  }
  .qr-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .qr-empty {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #999;
    font-weight: 500;
    letter-spacing: 1px;
    background: repeating-linear-gradient(
      45deg,
      #f5f5f5,
      #f5f5f5 6px,
      #ececec 6px,
      #ececec 12px
    );
    border-radius: 4px;
  }
  .qr-platform {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 13px;
    color: #333;
    font-weight: 500;
    .platform-icon {
      font-size: 14px;
    }
    &.android { color: #3DDC84; }
    &.ios { color: #333; }
  }
}

/* 猜你喜欢 */
.recommend-card {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.recommend-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.recommend-item {
  text-align: center;
  cursor: pointer;
  padding: 8px 4px;
  border-radius: 8px;
  transition: background 0.2s, transform 0.2s;
  &:hover {
    background: #f5f9ff;
    transform: translateY(-2px);
    .recommend-icon { box-shadow: 0 6px 14px rgba(74,144,226,0.25); }
  }
  .recommend-icon {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    overflow: hidden;
    margin: 0 auto 6px;
    background: #f0f0f0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: box-shadow 0.2s;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .recommend-name {
    font-size: 12px;
    color: #555;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* 页脚 */
.footer {
  background: #222222;
  color: #ccc;
  padding: 30px 0;
  .footer-inner {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
  }
  .footer-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 14px;
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;
      background: #fff;
      display: block;
    }
  }
  .footer-links {
    margin-bottom: 12px;
    a {
      color: #ccc;
      font-size: 13px;
      cursor: pointer;
      transition: color 0.2s;
      &:hover { color: #4A90E2; }
    }
    .divider {
      color: #555;
      margin: 0 8px;
      font-size: 12px;
    }
  }
  .footer-copyright {
    font-size: 12px;
    color: #888;
    line-height: 1.8;
  }
}
</style>
